import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import InternacionalMenu from '../../components/ui/InternacionalMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';
import BannerSection from '../../components/ui/BannerSection';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Internacional' },
    { label: 'Estudante Internacional' }
];


function estudante() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
         <BannerSection
            title="Estudante Universitário Internacional"
            subtitle="Bem-vindo ao Instituto Superior Politécnico Atlântida"
            description={`Fica por dentro de todas as informações necessárias para a sua jornada acadêmica no Ispa Atlântida, desde o processo de candidatura até a vida estudantil.`}
            backgroundImage={require('../../assets/BannerInsternacional.jpg')} 
            backgroundId="instituition-Banner"
            />
        <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <br />
            <div className="row flex-row-reverse">
                <InternacionalMenu /> 
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div className="details-magazine" id='detalhes'>
                    <p className="f-reg">
                   <SectionHeading title="Candidato Internacional" />
                    <b>Os candidatos internacionais</b> que pretendam frequentar um curso conferente de grau integrado na nossa instituição têm a possibilidade de o fazer através do concurso especial para estudantes internacionais, desde que cumpram as condições de acesso e ingresso específicas da instituição a que se candidatam. <br /><br />
                    Para conhecer as condições especiais destinadas aos candidatos internacionais aos cursos do Ispa – Instituto Superior Politécnico Atlântida consulte dos cursos internacionais  , consoante o nível de ensino em que tem interesse.
                    <br /><br />
                    </p>
                    <br />
                </div>
                <br /><br />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            </main>
        <AppLayout />
        </>
    );
}

export default estudante;